// Constants
import appConstants from 'constants/app.constants';

const getConfigurationValue = (configurationKey: string): string => {
  const dictionary = JSON.parse(localStorage.getItem(appConstants.DICTIONARY) || '{}');
  return dictionary[configurationKey] || configurationKey;
};

export { getConfigurationValue };
